export const MuiTabs = {
    MuiTabs: {
        styleOverrides: {
            root: {
                minHeight: 27,
                marginBottom: '10px',
            },
            flexContainer: {
                width: 'fit-content',
                flexWrap: 'wrap',
            },
            indicator: {
                display: 'none',
            },
        },
    },
};
